import * as chatActions from './chat'
import * as types from './chatTypes'

export const chatTypes = types
export default chatActions
